const DEFAULT_BATCH_SIZE = 100;
export const REPORT_EXPORT_BATCH_SIZE = DEFAULT_BATCH_SIZE;
/**
 * Loads a full report dataset in fixed-size pages to avoid oversized single requests.
 */
export async function fetchAllPagedReportRows(options) {
    const batchSize = Math.max(1, options.batchSize ?? DEFAULT_BATCH_SIZE);
    if (options.signal?.aborted) {
        throw new DOMException('Aborted', 'AbortError');
    }
    const probe = await options.fetchPage({ ...options.query, page: 0, size: 1 });
    const total = Math.max(probe.total, 0);
    if (total === 0) {
        options.onProgress?.({
            fetchedCount: 0,
            totalCount: 0,
            completedBatches: 0,
            totalBatches: 0,
        });
        return { rows: [], total: 0 };
    }
    const totalBatches = Math.ceil(total / batchSize);
    const allRows = [];
    for (let page = 0; page < totalBatches; page += 1) {
        if (options.signal?.aborted) {
            throw new DOMException('Aborted', 'AbortError');
        }
        const result = await options.fetchPage({
            ...options.query,
            page,
            size: batchSize,
        });
        allRows.push(...result.rows);
        options.onProgress?.({
            fetchedCount: Math.min(allRows.length, total),
            totalCount: total,
            completedBatches: page + 1,
            totalBatches,
        });
        if (result.rows.length === 0 || allRows.length >= total) {
            break;
        }
    }
    return { rows: allRows, total };
}
export function pagedFetchProgressPercent(progress) {
    if (progress.totalCount <= 0)
        return 0;
    return Math.min(100, Math.round((progress.fetchedCount / progress.totalCount) * 100));
}
/** Human-readable ETA from elapsed time and rows fetched so far. */
export function formatExportRemainingTime(remainingMs) {
    if (remainingMs == null || remainingMs <= 0) {
        return 'Calculating…';
    }
    const totalSeconds = Math.max(1, Math.ceil(remainingMs / 1000));
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    if (hours > 0) {
        return `~${hours}h ${minutes}m remaining`;
    }
    if (minutes > 0) {
        return `~${minutes}m ${seconds}s remaining`;
    }
    return `~${seconds}s remaining`;
}
